// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clannad-date-picker > .rc-calendar {\r\n  box-shadow: unset;\r\n}\r\n\r\n.clannad-date-picker .rc-calendar-date-panel {\r\n  min-width: 200px;\r\n  background-color: #ffffff;\r\n  box-shadow: 0px 4px 8px -2px rgb(9 30 66 / 25%),\r\n    0px 0px 1px 0px rgb(9 30 66 / 31%);\r\n}\r\n\r\n.clannad-date-picker .rc-calendar-input-wrap {\r\n  border: 1px solid rgb(165, 173, 186) !important;\r\n  border-radius: 3px;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
